(function () {
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function initAnnouncement() {
    var bar = qs('[data-announcement-bar]');
    if (!bar) return;

    var slides = qsa('[data-announcement-slide]', bar);
    if (!slides.length) return;

    var index = 0;
    var visible = true;
    var message = qs('[data-announcement-message]', bar);

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      if (message) {
        message.style.opacity = '1';
      }
      visible = true;
    }

    function transitionTo(nextIndex) {
      if (!visible) return;
      visible = false;
      if (message) {
        message.style.opacity = '0';
      }
      window.setTimeout(function () {
        show(nextIndex);
      }, 300);
    }

    var prev = qs('[data-announcement-prev]', bar);
    var next = qs('[data-announcement-next]', bar);

    if (prev) prev.addEventListener('click', function () { transitionTo(index - 1); });
    if (next) next.addEventListener('click', function () { transitionTo(index + 1); });

    window.setInterval(function () {
      transitionTo(index + 1);
    }, 3000);
  }

  function initDrawer() {
    var drawer = qs('[data-menu-drawer]');
    if (!drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }

    qsa('[data-menu-open]').forEach(function (button) {
      button.addEventListener('click', openDrawer);
    });

    qsa('[data-menu-close]', drawer).forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) closeDrawer();
    });
  }

  function initAccordions() {
    qsa('[data-accordion]').forEach(function (accordion) {
      var items = qsa('[data-accordion-item]', accordion);
      items.forEach(function (item) {
        var trigger = qs('[data-accordion-trigger]', item);
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var otherTrigger = qs('[data-accordion-trigger]', other);
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function initTabs() {
    qsa('[data-tabs]').forEach(function (tabs) {
      var buttons = qsa('[data-tab-button]', tabs);
      var panels = qsa('[data-tab-panel]', tabs);

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-tab-button');

          buttons.forEach(function (other) {
            other.classList.toggle('is-active', other === button);
            other.setAttribute('aria-selected', other === button ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
          });
        });
      });
    });
  }

  function initProductForms() {
    qsa('[data-product-form]').forEach(function (form) {
      var dataNode = qs('[data-variant-json]', form);
      var variantData = {};

      if (dataNode) {
        try {
          variantData = JSON.parse(dataNode.textContent || '{}');
        } catch (error) {
          variantData = {};
        }
      }

      var section = form.closest('[data-product-section]');
      var idInput = qs('[data-variant-id]', form);
      var addButton = qs('[data-add-button]', form);
      var buttonLabel = qs('[data-add-label]', form);
      var originalLabel = buttonLabel ? buttonLabel.textContent : '';
      var addUrl = form.action || '/cart/add.js';
      if (addUrl.indexOf('/cart/add.js') === -1) {
        addUrl = addUrl.indexOf('/cart/add') !== -1 ? addUrl.replace('/cart/add', '/cart/add.js') : '/cart/add.js';
      }

      function updateMainImage(imageSrc, imageAlt) {
        var image = qs('[data-main-product-image]', section);
        if (image && imageSrc) {
          image.src = imageSrc;
          if (imageAlt) image.alt = imageAlt;
        }
      }

      function setActiveThumbnail(activeButton) {
        qsa('[data-product-thumbnail]', section).forEach(function (button) {
          button.classList.toggle('is-active', button === activeButton);
        });
      }

      function applyVariant(id, imageSrc, imageAlt, activeButton) {
        var variant = id ? variantData[String(id)] : null;

        if (!variant) {
          updateMainImage(imageSrc, imageAlt);
          if (activeButton) setActiveThumbnail(activeButton);
          return;
        }

        if (idInput) idInput.value = id;

        updateMainImage(imageSrc || variant.image, imageAlt || variant.imageAlt);

        var map = {
          '[data-product-label]': variant.label,
          '[data-product-price]': variant.price,
          '[data-product-compare]': variant.compareAt,
          '[data-product-subtitle]': variant.subtitle,
          '[data-product-description]': variant.description,
          '[data-product-box-title]': variant.boxTitle,
          '[data-product-box-body]': variant.heading,
          '[data-product-offer]': variant.offerLabel
        };

        Object.keys(map).forEach(function (selector) {
          var node = qs(selector, section);
          if (node && map[selector] !== undefined) node.textContent = map[selector] || '';
        });

        var highlightList = qs('[data-product-highlights]', section);
        if (highlightList && Array.isArray(variant.highlights)) {
          highlightList.innerHTML = '';
          variant.highlights.forEach(function (item) {
            var li = document.createElement('li');
            li.textContent = item;
            highlightList.appendChild(li);
          });
        }

        if (activeButton) setActiveThumbnail(activeButton);

        if (addButton) addButton.disabled = !variant.available;
        if (buttonLabel) {
          buttonLabel.textContent = variant.available
            ? 'GET INSTANT ACCESS \u2014 ' + variant.price
            : 'SOLD OUT';
          originalLabel = buttonLabel.textContent;
        }
      }

      qsa('[data-product-thumbnail]', section).forEach(function (button) {
        button.addEventListener('click', function () {
          var id = button.getAttribute('data-variant-id');
          var imageSrc = button.getAttribute('data-media-src');
          var imageAlt = button.getAttribute('data-media-alt');
          if (id || imageSrc) applyVariant(id, imageSrc, imageAlt, button);
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!addButton || addButton.disabled) return;

        addButton.disabled = true;
        if (buttonLabel) buttonLabel.textContent = 'ADDING...';

        fetch(addUrl, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
/* commented by fj_design
          .then(function () {
            if (buttonLabel) buttonLabel.textContent = 'ADDED TO CART';
          })
*/
.then(function () {
  var root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  window.location.href = root + 'cart';
})
          .catch(function () {
            if (buttonLabel) buttonLabel.textContent = 'PLEASE TRY AGAIN';
          })
          .finally(function () {
            window.setTimeout(function () {
              addButton.disabled = false;
              if (buttonLabel) buttonLabel.textContent = originalLabel;
            }, 1400);
          });
      });
    });
  }

  function initCart() {
    var cart = qs('[data-cart]');
    if (!cart) return;

    var currency = cart.getAttribute('data-currency') || 'USD';
    var emptyState = qs('[data-cart-empty]', cart);
    var filledState = qs('[data-cart-filled]', cart);
    var subtotalNode = qs('[data-cart-subtotal]', cart);
    var countNode = qs('[data-cart-count]', cart);
    var changeUrl = cart.getAttribute('data-cart-change-url') || '/cart/change.js';
    var updateUrl = cart.getAttribute('data-cart-update-url') || '/cart/update.js';

    function setLoading(line, loading) {
      if (!line) return;
      line.style.opacity = loading ? '0.55' : '';
      qsa('button,input', line).forEach(function (control) {
        control.disabled = loading;
      });
    }

    function updateLine(line, item) {
      if (!line || !item) return;
      var input = qs('[data-quantity-input]', line);
      var price = qs('[data-line-price]', line);

      if (input) input.value = item.quantity;
      if (price) price.textContent = formatMoney(item.final_line_price, currency);
    }

    function updateCartDom(data) {
      if (subtotalNode) subtotalNode.textContent = formatMoney(data.total_price, data.currency || currency);
      if (countNode) countNode.textContent = data.item_count;

      qsa('[data-cart-line]', cart).forEach(function (line) {
        var key = line.getAttribute('data-line-key');
        var item = data.items.find(function (candidate) {
          return candidate.key === key;
        });

        if (!item || item.quantity < 1) {
          line.remove();
        } else {
          updateLine(line, item);
          setLoading(line, false);
        }
      });

      if (data.item_count < 1) {
        if (emptyState) emptyState.hidden = false;
        if (filledState) filledState.hidden = true;
      }
    }

    function changeLine(line, quantity) {
      var key = line.getAttribute('data-line-key');
      setLoading(line, true);

      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) { return response.json(); })
        .then(updateCartDom)
        .catch(function () { setLoading(line, false); });
    }

    qsa('[data-quantity-button]', cart).forEach(function (button) {
      button.addEventListener('click', function () {
        var line = button.closest('[data-cart-line]');
        var input = qs('[data-quantity-input]', line);
        var current = parseInt(input.value, 10) || 0;
        var delta = button.getAttribute('data-quantity-button') === 'plus' ? 1 : -1;
        changeLine(line, Math.max(0, current + delta));
      });
    });

    qsa('[data-quantity-input]', cart).forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.closest('[data-cart-line]');
        changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
      });
    });

    qsa('[data-remove-line]', cart).forEach(function (button) {
      button.addEventListener('click', function () {
        var line = button.closest('[data-cart-line]');
        changeLine(line, 0);
      });
    });

    var note = qs('[data-cart-note]', cart);
    if (note) {
      note.addEventListener('change', function () {
        fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ note: note.value })
        });
      });
    }

    var form = qs('[data-cart-form]', cart);
    var discount = qs('[data-discount-code]', cart);
    if (form && discount) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
        var code = discount.value.trim();
        if (!code) return;
        event.preventDefault();
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initDrawer();
    initAccordions();
    initTabs();
    initProductForms();
    initCart();
  });
})();
